<template lang="pug">
p.footer-copyright(v-html="copyrightText")
</template>
<script>
export default {
  name: "FooterCopyright",
  props: {
    copyright: {
      required: true,
      type: String,
    },
  },
  computed: {
    getYear() {
      return new Date().getFullYear();
    },
    copyrightText() {
      return `&copy; ${ this.getYear } ${ this.copyright }`
    },
  },
}
</script>